import { endpointsList } from '@/helpers';
import axios from 'axios';
import {
  DEFAULT_METADATA_VALUES_SEPARATOR,
  IUpdateMetadataOfMultipleDocumentsDto,
  ProjectType,
} from 'types';

export class MetadataUpdateService {
  constructor(private readonly mode: ProjectType) {}

  public async updateMultiValueMetadataProperty(payload: {
    projectId: string;
    documentOid: string;
    metadataField: string;
    values: string[];
  }): Promise<void> {
    const joinedString = payload.values.join(DEFAULT_METADATA_VALUES_SEPARATOR);

    if (this.mode === ProjectType.SUPPLIER_PROJECT) {
      await axios.post(
        endpointsList.documentsUploads.updateValuesOfEditableMetadataFields(
          payload.documentOid,
        ),
        {
          [payload.metadataField]: joinedString,
        },
      );
    } else if (this.mode === ProjectType.DIGITALIZATION_PROJECT) {
      const dto: IUpdateMetadataOfMultipleDocumentsDto = {
        [payload.documentOid]: {
          [payload.metadataField]: joinedString,
        },
      };

      await axios.patch(
        endpointsList.digitalizationUploads.updateMetadataOfMultipleDocuments(
          payload.projectId,
          false,
        ),
        dto,
      );
    }
  }
}
